import { useMediaQuery } from '@mui/material';
import { encode as base64_encode, decode } from 'base-64';

const ASPECT_RATION = 16/9;
const MAX_PLAYER_WIDTH = 1200;
export function getYouTubeEmbedId(url) {
    // Regular expression patterns for different YouTube URL formats
    const patterns = [
      /^https?:\/\/(?:[mw]+\.)?youtube\.com\/watch\?v=([^&]+)/i, // Standard watch URL
      /^https?:\/\/(?:[mw]+\.)?youtube\.com\/embed\/([^/?]+)/i, // Embed URL
      /^https?:\/\/(?:[mw]+\.)?youtu\.be\/([^/?]+)/i, // Shortened URL
      /^https?:\/\/(?:[mw]+\.)?youtube\.com\/v\/([^/?]+)/i, // Old-style URL
      /^https?:\/\/(?:[mw]+\.)?youtube\.com\/user\/\S+\?v=([^&]+)/i, // User URL
      /^https?:\/\/(?:[mw]+\.)?youtube\.com\/watch\?t=[\.\d]+&v=([^&]+)/i,
  ];

  // Loop through the patterns and try to match the URL
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }  
    // If no match is found, return null
  return null;
}

export const getWidthByBreakpoint = (theme) => {
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isExtraExtraLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));

  if (isMediumScreen) {
    return "100%";
  } else if (isLargeScreen) {
    return 300;
  } else if (isExtraLargeScreen) {
    return 600;
  } else if (isExtraLargeScreen) {
    return 900;
  } else {
    return 1200;
  }
};

  export const getHeightByAspectRatio = (width) => {
    return width / ASPECT_RATION;
  };

  export const getHeightByGridWidthAspectRatio = (gridRef) => {
    if (gridRef && gridRef.current) {
      const gridWidth =  gridRef.current.offsetWidth;
      return gridWidth / ASPECT_RATION;
      }
    
      return MAX_PLAYER_WIDTH / ASPECT_RATION;
  };

  export function encodeUrl(embedId, bookmark) {
    const encodedLink = base64_encode(
      JSON.stringify({
      embedId: embedId,
      bookmark: bookmark.slice(0, -1),
      })
    )

    return encodedLink;
  }

  export function encodeUrlWithOnlyBookmark(bookmark) {
    const encodedLink = base64_encode(
      JSON.stringify({
        bookmark: bookmark.slice(0, -1),
      })
    )

    return encodedLink;
  }

  export function decodeBookmarks(encodedBookmark) {
    const dcode = JSON.parse(decode(encodedBookmark));

    /*
    ["bookmarks", "section"].forEach((value)=> {
      if (!dcode.hasOwnProperty(value)) {
        return null;
      }
    });
    */
    return dcode;
  }